export default __webpack_public_path__ + "static/individualEnglishCard-0b989a9d68425f37df2b23dd73f2d0d5.png";